import { c as _c } from "react/compiler-runtime";
import type { InsightEvent } from '@onefootprint/request-types/dashboard';
import { LinkButton, Popover } from '@onefootprint/ui';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { displayForUserAgent } from '@/utils/user-agent';
import getRegion from './utils/get-region';
export type InsightEventPopoverProps = {
  insightEvent: InsightEvent;
  children: string;
};
const InsightEventPopover = t0 => {
  const $ = _c(53);
  const {
    insightEvent,
    children
  } = t0;
  const popOverRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "components.insightEventPopover"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("common", t1);
  const {
    city,
    country,
    ipAddress,
    region,
    userAgent,
    postalCode
  } = insightEvent;
  const t2 = city ?? null;
  const t3 = region ?? null;
  let t4;
  if ($[1] !== t2 || $[2] !== t3) {
    t4 = getRegion(t2, t3);
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const fullRegion = t4;
  let t5;
  if ($[4] !== t) {
    t5 = t(_temp);
    $[4] = t;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== fullRegion || $[7] !== t5) {
    t6 = {
      label: t5,
      value: fullRegion
    };
    $[6] = fullRegion;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t) {
    t7 = t(_temp2);
    $[9] = t;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== country || $[12] !== t7) {
    t8 = {
      label: t7,
      value: country
    };
    $[11] = country;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t) {
    t9 = t(_temp3);
    $[14] = t;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== postalCode || $[17] !== t9) {
    t10 = {
      label: t9,
      value: postalCode
    };
    $[16] = postalCode;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t) {
    t11 = t(_temp4);
    $[19] = t;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== ipAddress || $[22] !== t11) {
    t12 = {
      label: t11,
      value: ipAddress
    };
    $[21] = ipAddress;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t) {
    t13 = t(_temp5);
    $[24] = t;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== userAgent) {
    t14 = userAgent && displayForUserAgent(userAgent);
    $[26] = userAgent;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t13 || $[29] !== t14) {
    t15 = {
      label: t13,
      value: t14
    };
    $[28] = t13;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t10 || $[32] !== t12 || $[33] !== t15 || $[34] !== t6 || $[35] !== t8) {
    t16 = [t6, t8, t10, t12, t15];
    $[31] = t10;
    $[32] = t12;
    $[33] = t15;
    $[34] = t6;
    $[35] = t8;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  const insightList = t16;
  const hasValidInsights = insightList.some(_temp6);
  if (!hasValidInsights) {
    let t17;
    if ($[37] !== children) {
      t17 = <p className="text-label-2">{children}</p>;
      $[37] = children;
      $[38] = t17;
    } else {
      t17 = $[38];
    }
    return t17;
  }
  let t17;
  if ($[39] !== t) {
    t17 = t(_temp7);
    $[39] = t;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t17) {
    t18 = <p className="text-label-2">{t17}</p>;
    $[41] = t17;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== insightList) {
    t19 = <div className="flex flex-col gap-1">{insightList.map(_temp8)}</div>;
    $[43] = insightList;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== t18 || $[46] !== t19) {
    t20 = <div className="flex flex-col gap-2 p-2 max-md:max-w-[calc(100vw-32px)]" ref={popOverRef}>{t18}{t19}</div>;
    $[45] = t18;
    $[46] = t19;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  const PopoverContent = t20;
  let t21;
  if ($[48] !== children) {
    t21 = <LinkButton variant="label-2">{children}</LinkButton>;
    $[48] = children;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] !== PopoverContent || $[51] !== t21) {
    t22 = <Popover content={PopoverContent}>{t21}</Popover>;
    $[50] = PopoverContent;
    $[51] = t21;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  return t22;
};
export default InsightEventPopover;
function _temp($) {
  return $.region;
}
function _temp2($_0) {
  return $_0.country;
}
function _temp3($_1) {
  return $_1.postalCode;
}
function _temp4($_2) {
  return $_2.ipAddress;
}
function _temp5($_3) {
  return $_3.deviceOs;
}
function _temp6(t0) {
  const {
    label,
    value
  } = t0;
  return label && value;
}
function _temp7($_4) {
  return $_4.insights;
}
function _temp8(t0) {
  const {
    label: label_0,
    value: value_0
  } = t0;
  return <div className="flex justify-between gap-5 min-w-[240px]" key={label_0}><p className="text-label-2 text-tertiary max-md:shrink-0">{label_0}</p><p className="text-body-2 text-tertiary max-md:min-w-0 max-md:text-right max-md:wrap-anywhere">{value_0}</p></div>;
}